import React from 'react';
import { connectModal } from 'redux-modal';
import { Button, Modal } from 'react-bootstrap';
import { MHT_SETUP_ERROR_MODAL } from 'misc/constants';


const MHTSetupErrorModal = (props) => {

  const { 
    show,
    handleHide,
    message,
  } = props;
  
  return (
    <Modal
      show={show}
      onHide={handleHide}
      animation={true}
      backdrop="static"
      className="modal-danger">
      <Modal.Header closeButton>
        <Modal.Title>MHT Setup Error</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="pull-right btn-outline"
          bsSize="sm"
          bsStyle="danger"
          type="button"
          onClick={handleHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default connectModal({ name: MHT_SETUP_ERROR_MODAL })(MHTSetupErrorModal)

